import axios from 'axios'

const Http = axios.create()
delete Http.defaults.headers.common['Authorization']

if (!(typeof process === 'undefined' || process === null)) console.log(process)

export const getAPICredentials = () => {
    const {
        VUE_APP_HERE_APP_ID,
        VUE_APP_HERE_APP_CODE,
        MIX_HERE_APP_ID,
        MIX_HERE_APP_CODE,
    } = process.env

    return {
        appId: VUE_APP_HERE_APP_ID || MIX_HERE_APP_ID,
        appCode: VUE_APP_HERE_APP_CODE || MIX_HERE_APP_CODE,
        autocompleteURL:
            'https://autocomplete.search.hereapi.com/v1/autocomplete',
        locationURL: 'https://geocode.search.hereapi.com/v1/geocode',
    }
}

export const getJSCredentials = () => {
    const {
        VUE_APP_HERE_APP_ID,
        VUE_APP_HERE_APP_CODE,
        MIX_HERE_APP_ID,
        MIX_HERE_APP_CODE,
    } = process.env

    return {
        appId: VUE_APP_HERE_APP_ID || MIX_HERE_APP_ID,
        apiKey: VUE_APP_HERE_APP_CODE || MIX_HERE_APP_CODE,
    }
}

export const autocomplete = async (query, options = {}) => {
    if (!query) return []
    const { appCode, autocompleteURL } = getAPICredentials()

    const { data } = await Http.get(autocompleteURL, {
        params: {
            apiKey: appCode,
            q: query,
            in: 'countryCode:AUS',
            beginHighlight: '<b>',
            endHighlight: '</b>',
            additionaldata: 'IncludeMicroPointAddresses,true',
            ...options,
        },
    })

    return data.items || []
}

export const geocode = async (query, options = {}) => {
    if (!query) return null
    const { appCode, locationURL } = getAPICredentials()

    const { data } = await Http.get(locationURL, {
        params: {
            apiKey: appCode,
            q: query,
            ...options,
        },
    })

    return data.items[0]
}

export default {
    autocomplete,
    geocode,
}
